import React, { useState } from "react";
import { compose } from "recompose";
import { Table, Modal, ModalHeader, ModalBody, Button, Badge } from "reactstrap";
import { withTable, EditDeleteButtonsModal, Page } from "components/common";
import { Trans } from "react-i18next";
import Edit from "./Edit";
import BackButton from "./../BackButton";

export const List = ({
  TableContainer,
  payroll,
  client,
  t,
  url = "end_of_service",
  model = "local",
  data,
  PayrollTableDataFetch,
  PayrollBulkDeleteButton,
  onDeleteItem,
  match,
  props,
}) => {
  const [modal, setModal] = useState(false);
  const toggleModal = () => setModal(!modal);

  const [listItem, setListItem] = useState([])
  const [id, setId] = useState("new")
  const [allowances, setAllowances] = useState([]);
  const [endOfServices, setEndOfServices] = useState([]);


  const updateList = async () => {
    setModal(false)
    const data = await payroll.get(`end_of_service`).get("data");
    setListItem(data)
  }


  React.useEffect(() => {
    updateList()
    void (async () => {
      const _allowances = await payroll.get("allowance_rules/allowances_options").get("data");
      setAllowances(_allowances);
      const endOfService_list = await payroll.get("end_of_service_benefits").get("data");
      setEndOfServices(endOfService_list);
    })()
  }, [])

  React.useEffect(() => {
    updateList()
  }, [data])

  function onDelete(id) {
    payroll.delete(
      `end_of_service_benefits/${id}`
    ).then((data) => {
      Notification.success(t('Deleted Successfully'))
    }).catch((err) => {
      Notification.error(t('Deleted Successfully'))
    })
    Notification.success(t('Deleted Successfully'))
  }

  return (
    <Page title="" className="inv-table">
      {/* <BackButton/> */}
      <h4 style={{ marginTop: "15px", marginBottom: "20px" }}><Trans>End Of Service Rules</Trans></h4>
      <PayrollBulkDeleteButton className="d-none" />

      <Button onClick={(e) => { toggleModal(); setId("new") }} color="success" className="bt float-left mb-4" type="add">
        <i className="fa fa-plus mr-2" aria-hidden="true"></i>
        <Trans>Add New</Trans>
      </Button>

      <TableContainer className="border">
        <Table>
          <thead>
            <tr>
              <th style={{ padding: "1rem" }} className="text-nowrap">
                <Trans>Name</Trans>
              </th>
              <th sortBy="amount" className="text-nowrap">
                <Trans>Days Base</Trans>
              </th>
              <th>
                <Trans>Status</Trans>
              </th>
              <th>
                <Trans>Actions</Trans>
              </th>
            </tr>
          </thead>
          <tbody>
            {listItem?.length > 0 ?
              listItem.map((i) => (
                <tr key={i.id}>
                  <td>{i.name} </td>
                  <td>{i.days_base}</td>
                  <td>{i.is_default && <Badge pill><Trans>default</Trans></Badge>}</td>
                  <td className="text-end text-nowrap">
                    <EditDeleteButtonsModal
                      url={match.url}
                      id={i.id}
                      onDelete={onDeleteItem}
                      onEdit={(e) => { setId(`${i.id}`); toggleModal(); }}
                    />
                  </td>
                </tr>
              )) :
              <tr>
                <td colSpan={4}>
                  <Trans>No records found</Trans>
                </td>
              </tr>
            }
          </tbody>
        </Table>
      </TableContainer>
      <PayrollTableDataFetch />


      {endOfServices?.length > 0 &&
        <>
          <h4 className="mb-2 my-4"><Trans><Trans>Accrued end of service benefits to pay</Trans></Trans></h4>
          <div className="accrued-eos border">
            <Table>
              <thead>
                <tr>
                  <th className="text-nowrap">
                    <Trans>Description</Trans>
                  </th>
                  <th sortBy="amount" className="text-nowrap">
                    <Trans>Employee</Trans>
                  </th>
                  <th sortBy="amount_type" className="text-nowrap">
                    <Trans>Total</Trans>
                  </th>
                  <th sortBy="amount_type" className="text-nowrap">
                    <Trans>Amount Accrued</Trans>
                  </th>
                  <th sortBy="amount_type" className="text-nowrap">
                    <Trans>Total Working Days</Trans>
                  </th>
                  <th sortBy="amount_type" className="text-nowrap">
                    <Trans>Status</Trans>
                  </th>
                  <th>
                    <Trans>Actions</Trans>
                  </th>
                </tr>
              </thead>
              <tbody>
                {endOfServices ?
                  endOfServices.map((i) => (
                    <tr key={i.id}>
                      <td>{i.description}</td>
                      <td>{i.employee_name}</td>
                      <td>{parseFloat(i.amount) + parseFloat(i.remaining)}</td>
                      <td>{i.amount}</td>
                      <td>{i.total_worked_days}</td>
                      <td>{i.paid ? "Paid" : 'Not Paid'}</td>
                      <td><EditDeleteButtonsModal
                        url={'end_of_service_benefits'}
                        id={i.id}
                        onDelete={onDelete}
                        hideEdit={true}
                      /></td>
                    </tr>
                  ))
                  :
                  <Trans>No Data to Load</Trans>
                }
              </tbody>
            </Table>
          </div>
        </>
      }

      <Modal isOpen={modal} toggle={toggleModal} {...props}>
        <ModalHeader toggle={toggleModal}><Trans>Create End Of Service Rule</Trans></ModalHeader>
        <ModalBody style={{ overflowY: 'visible' }}>

          <Edit {...props} _payroll={payroll} updateList={updateList} id={id} allowances={allowances} t={t} />

        </ModalBody>

      </Modal>
    </Page>
  )
};

const enhance = compose(withTable({ limit: 99999, url: "end_of_service" }));

export default enhance(List);
